import type { RovoChatSourceMode } from '@atlassian/conversation-assistant-service-api/types/assistance-service';

/**
 * Strict source mode is only valid for Space-scoped sends. Returning undefined
 * preserves the pre-feature request shape for every other caller.
 */
export function getSpaceScopedSourceMode({
	sourceMode,
	spaceId,
}: {
	sourceMode?: RovoChatSourceMode;
	spaceId?: string;
}): RovoChatSourceMode | undefined {
	return spaceId ? sourceMode : undefined;
}
